import { type ApiClient, HubspotTrackArgs } from '@prismo-io/schemas';

export const sendLeadHasClickedHubspot = async (
  client: ApiClient
): Promise<boolean> => {
  const params = HubspotTrackArgs.parse({ cliquer_app_lead_teasing: true });

  const { data } = await client
    .rpc('hubspot_track', params)
    .maybeSingle()
    .throwOnError();

  return data || false;
};
